<template>
    <div>
        <div class="container" v-if="list.length">
            <div class="data_ctrl">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-button v-if="['release', 'passed'].includes(page)" class="ml" type="primary" size="small" @click="handleCtrlExecute(1)">屏蔽</el-button>
                <el-button v-if="['release'].includes(page)" class="ml" type="primary" size="small" @click="handleCtrlExecute(2)">通过</el-button>
                <el-button v-if="['blocked'].includes(page)" class="ml" type="primary" size="small" @click="handleCtrlExecute(2)">通过</el-button>
                
                <span class="preview_num" v-if="checked.length">已选择<em>{{checked.length}}</em>个</span>
            </div>
            
            <div class="data_list" v-loading="loading">
                <div
                    class="item"
                    v-for="(item, i) in list"
                    :key="i"
                >
                    <div class="resource" @click="handleSelectResource(item)">
                        <div class="checkbox" :class="{ 'on': checked.findIndex(v => v.material_id === item.material_id) >= 0 }"></div>
                        <div class="poster" :class="{ 'img_group': item.material_previewer.length > 1}">
                            <template v-if="item.material_previewer && item.material_previewer.length && item.material_previewer[0].indexOf('mp4') >= 0">
                                <div class="ico_video" @click.stop="handleOpenDetail(item)">
                                    <svg t="1713855455572" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6925" width="40" height="40"><path d="M416 704c-6.4 0-9.6 0-16-3.2C390.4 694.4 384 684.8 384 672L384 352c0-12.8 6.4-22.4 16-28.8 9.6-6.4 22.4-6.4 32 0l256 166.4c9.6 6.4 16 16 16 28.8 0 9.6-6.4 22.4-16 25.6l-256 156.8C428.8 704 422.4 704 416 704zM448 409.6l0 204.8 163.2-99.2L448 409.6z" p-id="6926" fill="#e6e6e6"></path><path d="M512 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448S758.4 960 512 960zM512 128C300.8 128 128 300.8 128 512c0 211.2 172.8 384 384 384 211.2 0 384-172.8 384-384C896 300.8 723.2 128 512 128z" p-id="6927" fill="#e6e6e6"></path></svg>
                                </div>
                                <video :src="item.material_previewer[0]" :poster="item.material_poster"></video>
                            </template>
                            <template v-else>
                                <img
                                    v-for="(cItem, cIndex) in item.material_previewer"
                                    :key="cIndex"
                                    :src="cItem"
                                    :alt="item.material_title"
                                >
                            </template>
                        </div>
                        <div class="btns">
                            <!-- <a href="javascript:;" v-if="['stay'].includes(page)" @click.stop="handleCtrlExecuteSingle(item, 1)">审核通过</a>-->
                            <a href="javascript:;" @click.stop="handleOpenDetail(item)">查看详情</a>
                            <!-- <a href="javascript:;" v-if="['stay'].includes(page)" @click.stop="handleCtrlExecuteSingle(item, 2)">审核拒绝</a>-->
                        </div>
                    </div>
                    <div class="title">{{ item.material_title }}</div>
                    <div class="title">
                        <a :href="item.click_link" target="_blank">{{ item.click_link }}</a>
                    </div>
                </div>
            </div>
            
            <div class="page_preview">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handleChangePage"
                ></el-pagination>
            </div>
        </div>
        
        <el-empty v-if="!list.length" description="暂无数据" v-loading="loading"></el-empty>
        
        <!-- preview -->
        <el-dialog
            title="素材详情"
            width="60%"
            :visible.sync="dialogVisible"
            @close="handleOpenDetailClose"
        >
            <div class="preview">
                <div class="resource">
                    <div class="poster" :class="{ 'img_group': dialog.material_previewer && dialog.material_previewer.length > 1}">
                        <template v-if="dialog.material_previewer && dialog.material_previewer.length && dialog.material_previewer[0].indexOf('mp4') >= 0">
                            <video :src="dialog.material_previewer[0]" :poster="dialog.material_poster" autoplay controls ref="preview_video"></video>
                        </template>
                        <template v-else>
                            <img
                                v-for="(cItem, cIndex) in dialog.material_previewer"
                                :key="cIndex"
                                :src="cItem"
                                :alt="dialog.material_title"
                            >
                        </template>
                    </div>
                </div>
                <div class="text">
                    <span class="label">素材ID:</span>
                    <span class="cont">{{ dialog.material_id }}</span>
                </div>
                <div class="text">
                    <span class="label">产品名称:</span>
                    <span class="cont">{{ dialog.product_name }}</span>
                </div>
                <div class="text">
                    <span class="label">素材标题:</span>
                    <span class="cont">{{ dialog.material_title }}</span>
                </div>
                <div class="text">
                    <span class="label">点击链接:</span>
                    <span class="cont">
                        <a :href="dialog.click_link" target="_blank">{{ dialog.click_link }}</a>
                    </span>
                </div>
                <div class="text">
                    <span class="label">Deeplink:</span>
                    <span class="cont">{{ dialog.deep_link }}</span>
                </div>
                <div class="btns">
                    <el-button v-if="['release', 'passed'].includes(page)" type="primary" @click="handleCtrlExecuteSingle(dialog, 1)">屏蔽</el-button>
                    <el-button v-if="['release'].includes(page)" type="primary" @click="handleCtrlExecuteSingle(dialog, 2)">通过</el-button>
                    <el-button v-if="['blocked'].includes(page)" type="primary" @click="handleCtrlExecuteSingle(dialog, 2)">通过</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getReviewReleaseList, getReviewBlockedList, getReviewPassedList, setReviewCollection } from '@/apis/advCenter.js';

export default {
    name: 'audit-list',
    data() {
        return {
            isIndeterminate: false,
            checkAll: false,
            checked: [],
            
            loading: false,
            pageNum: 1,
            pageSize: 100,
            list: [],
            total: 0,
            
            dialogVisible: false,
            dialog: {}
        }
    },
    
    props: {
        page: String,
        search: Object,
        collectionId: [Number, String],
        reload: Boolean
    },
    
    watch: {
        reload(oldVal, newVal) {
            console.log('list watch reload >>> ', oldVal, newVal);
            if (oldVal) {
                this.reset();
                this.getList();
                this.$emit('update:reload', false);
            }
        },
        search(oldVal, newVal) {
            console.log('list watch search >>> ', oldVal, newVal);
            this.reset();
            this.getList();
        },
        collectionId(oldVal, newVal) {
            console.log('ist watch collectionId >>> ', oldVal, newVal);
            this.reset();
            this.getList();
        }
    },
    
    methods: {
        init() {
        },
        
        reset() {
            this.pageNum = 1;
            this.list = [];
            this.isIndeterminate = false;
            this.checkAll = false;
            this.checked = [];
        },
        
        async getList() {
            console.log('this.search >>> ', this.search);
            if (!this.collectionId) return;
            this.loading = true;
            
            let params = {
                page: this.pageNum,
                page_size: this.pageSize,
                collection_id: this.collectionId
            }
            if (this.search.date && this.search.date.length) params['date'] = this.search.date[0] + '~' + this.search.date[1];
            if (this.search.keyword) params['idea_title'] = this.search.keyword;
            if (this.search.material_id) params['material_id'] = this.search.material_id;
            if (this.search.adSlotId) params['adslot_id'] = this.search.adSlotId;
            if (this.search.productName) params['product_name'] = this.search.productName;
            
            let res = null;
            if (['passed'].includes(this.page)) {
                res = await getReviewPassedList(params);
            } else if (['blocked'].includes(this.page)) {
                res = await getReviewBlockedList(params);
            } else {
                res = await getReviewReleaseList(params);
            }
            if (res.code && res.code === 200) {
                this.list = res.data.list;
                this.total = res.data.total;
            }
            this.loading = false;
        },
        
        // 单选
        handleSelectResource(item) {
            let findIndex = this.checked.findIndex(v => {
                return v.material_id === item.material_id;
            });
            if (findIndex >= 0) {
                this.checked.splice(findIndex, 1);
            } else {
                this.checked.push(item);
            }
            
            let checkedCount = this.checked.length;
            this.checkAll = checkedCount === this.list.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
        },
        
        // 全选
        handleCheckAllChange(val) {
            this.checked = val ? [...this.list] : [];
            this.isIndeterminate = false;
        },
        
        // 切换分页
        handleChangePage(n) {
            this.isIndeterminate = false;
            this.checkAll = false;
            this.checked = [];
            this.pageNum = n;
            this.getList();
            this.$emit('callback', { scrollTop: true })
        },
        
        // 操作(屏蔽&展示) - 单点
        handleCtrlExecuteSingle(obj, audit) {
            this.checked = [obj];
            this.handleCtrlExecute(audit);
        },
        
        // 操作(屏蔽&展示) - 批量
        async handleCtrlExecute(audit) {
            let ids = [];
            let version = {};
            let ids2 = []
            this.checked.forEach(v => {
                ids.push(v.material_md5);
                ids2.push(v.id);
                version[v.material_id] = v.version;
            });
            
            if (!ids.length) {
                this.$message.error('请选择素材');
                return;
            }
            if (!ids2.length) {
                this.$message.error('请选择素材');
                return;
            }
            
            const {code, message} = await setReviewCollection({
                collection_id: this.collectionId,
                material_md5: ids,
                record_ids: ids2,
                start_date: this.search.date[0],
                end_date: this.search.date[1],
                // version: version,
                audit
            });
            if (code && code === 200) {
                this.isIndeterminate = false;
                this.checkAll = false;
                this.checked = [];
                this.$message.success('操作成功');
                this.getList();
                this.$emit('callback', { listReload: true });
                this.dialogVisible = false;
            } else {
                this.$message.error(message);
            }
        },
        
        // 素材详情
        handleOpenDetail(item) {
            this.dialogVisible = true;
            this.dialog = {...item};
            this.$refs.preview_video && this.$refs.preview_video.play();
        },
        
        // 素材详情关闭
        handleOpenDetailClose() {
            this.$refs.preview_video && this.$refs.preview_video.pause();
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.container{
    position: sticky;
    top: 0;
    margin-top: 10px;
    & .data_ctrl{
        position: sticky;
        top: 40px;
        z-index: 2;
        padding-top: 5px;
        padding-bottom: 5px;
        background: #fff;
        & .ml{margin-left: 15px;}
        & .preview_num{
            margin-left: 15px;
            font-size: 14px;
            color: #555;
            & em{
                font-style: normal;
                color: #409EFF;
            }
        }
    }
    & .data_list{
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        & .item{
            margin-right: 2.3%;
            margin-bottom: 30px;
            padding: 12px;
            padding-bottom: 10px;
            width: 20%;
            display: flex;
            flex-direction: column;
            border: 1px solid #eee;
            box-shadow: 1px 3px 5px #eee;
            border-radius: 8px;
            
            & .resource{
                position: relative;
                margin-bottom: 6px;
                width: 100%;
                height: 160px;
                background: #f0f0f0;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover{
                    & .btns{display: flex;}
                }
                & .checkbox{
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    width: 15px;
                    height: 15px;
                    border: 1px solid #ccc;
                    background: #fff;
                    z-index: 1;
                    &.on{
                        background: #409EFF;
                        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAANZJREFUOE+9k6tOQ0EURdeSfAZ1Tar4ADS6pB5RBRgSBIoWhQIFpqg6FJ7wEQTbaiwWRXZ7SdtcHpdM04Sxc/Y5a+8zIxscN9Dyv+Ik98CberjW5CRjYFvdrewWi5OMgB7QUV9X4iRb6ntTeElugCNgT31c1n1OTvIEtICu+lJvkuQaOAFO1av63Qo7yR3QB47V20XTS+Bs7nOsHnwn++I5yXAOMgCqRCfAOfCs7vxm6UdgtQZV/QfQVqdF4gXukmBffWgKsnFVSQbqxV/Pt3jPxdiln2UGMbpBEKBjAjoAAAAASUVORK5CYII=');
                        background-size: cover;
                    }
                }
                & .poster{
                    position: relative;
                    max-width: 100%;
                    max-height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &.img_group{
                        & img{width: 33%;}
                    }
                    & .ico_video{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 40px;
                        height: 40px;
                        cursor: pointer;
                        z-index: 1;
                    }
                    & img, & video {
                        display: block;
                        max-width: 100%;
                        max-height: 160px;
                    }
                }
                & .btns{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 30px;
                    background: rgba(255, 255, 255, 0.7);
                    display: none;
                    justify-content: space-around;
                    align-items: center;
                    & a{
                        display: block;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        color: #409EFF;
                        font-size: 14px;
                        text-align: center;
                        text-decoration: none;
                    }
                }
            }
            & .title{
                height: 25px;
                line-height: 25px;
                font-size: 14px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                & a{
                    color: #666;
                    text-decoration: none;
                    &:hover{text-decoration: underline;}
                }
            }
        }
    }
    & .page_preview{
        padding-bottom: 20px;
        text-align: right;
    }
}

.preview {
    & .resource {
        position: relative;
        margin-bottom: 10px;
        width: 100%;
        height: 250px;
        background: #caced4;
        display: flex;
        justify-content: center;
        align-items: center;
        & .poster {
            max-width: 100%;
            max-height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &.img_group{
                & img{width: 33%;}
            }
            & img, & video {
                display: block;
                max-width: 100%;
                max-height: 250px;
            }
            & video{
                min-width: 200px;
                min-height: 250px;
            }
        }
    }
    & .text {
        padding: 3px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        & .label {
            width: 120px;
            text-align: right;
            font-size: 14px;
        }
        & .cont {
            margin-left: 10px;
            max-width: 680px;
            font-size: 14px;
            color: #666;
        }
    }
    & .btns{
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
